import React from 'react';
import { useFormikContext } from 'formik';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import ScreenTopBar from 'legacy/components/ScreenTopBar';
import FadeIn from 'legacy/common/components/transition/FadeIn';
import { useImageUploadCommand } from 'legacy/common/hooks/useImageUploadCommand';
import { showError } from 'legacy/common/utils/toast';
import { useMediaQuery } from 'theme/useMediaQuery';
import { Breakpoints, BreakpointsKeys } from 'theme/types';

import BottomBar from './components/BottomBar';
import DesktopForm from './components/DesktopForm';
import MobileForm from './components/MobileForm';
import EditOrgDesktopSkeleton from './components/EditOrgDesktopSkeleton';
import { useOrganization } from '../../context/EditOrganizationProvider';
import { EditOrganizationFormValues } from '../../types/edit-organization';

const EditOrganization = () => {
  const { t } = useTranslation(['organizations']);
  const { setFieldValue } = useFormikContext<EditOrganizationFormValues>();
  const uploadImageCommand = useImageUploadCommand();
  const { data } = useOrganization();
  const router = useRouter();
  // TODO: Manage screen sizes from within a shared hook inside the design system
  const isDesktop = useMediaQuery(
    `(min-width: ${Breakpoints[BreakpointsKeys.Tablet]}px)`
  );

  const uploadImage = (imageType: string) => async (blob: Blob) => {
    uploadImageCommand.mutate(
      { blob },
      {
        onSuccess: ({ imageUrl }) => {
          setFieldValue(imageType, imageUrl);
        },
        onError: (err) => {
          showError({
            title: t('errors.imageUploadError'),
            message: err.message
          });
        }
      }
    );
  };

  const goBack = () => {
    if (data.isEditing) {
      router.push(`/organizations/${data.organization.id}`);
    } else {
      router.push(`/dashboard`);
    }
  };

  if (data.isLoadingOrganization) {
    return <EditOrgDesktopSkeleton />;
  }

  return (
    <>
      <ScreenTopBar
        onBack={goBack}
        title={!data.isEditing ? t('actions.create') : t('actions.edit')}
      />
      <div className="md:pt-[46px] -mt-[41px] md:mt-0">
        <div className="relative z-1">
          <FadeIn>
            {isDesktop ? (
              <DesktopForm uploadImage={uploadImage} />
            ) : (
              <MobileForm uploadImage={uploadImage} />
            )}
          </FadeIn>
        </div>
      </div>
      <BottomBar />
    </>
  );
};

export default EditOrganization;
